function getDfeKeyNumber(key: string) {
    return parseInt(key.substring(25, 34), 10).toString();
}

export default getDfeKeyNumber;
